import { Config } from './generated/api.generated.v1';
import AuthService from './AuthService';
import axios, { AxiosRequestConfig, InternalAxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from 'axios';

const MAX_AUTH_RETRY = 1;

export default class ApiConfig implements Config {
  private static unAuthorizedHandlers: Array<() => void>;

  transformHeaders(options: AxiosRequestConfig): InternalAxiosRequestConfig {
    const castedOptions = <InternalAxiosRequestConfig>options;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    castedOptions.headers = <AxiosRequestHeaders>{
      ...castedOptions.headers,
      Authorization: this.getAuthorization()
    };

    return castedOptions;
  }

  async transformResult(
    url: string,
    response: AxiosResponse,
    processor: (response: AxiosResponse) => Promise<any> // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) {
    const isFromLogin: boolean = (response.config.url?.toLowerCase()?.indexOf('login') ?? 0) > -1;

    if (response.status == 401 && !isFromLogin) {
      await this._tryRefreshToken(response);
    }

    return processor(response);
  }

  private static _authRetryCount = 0;

  private async _tryRefreshToken(response: AxiosResponse) {
    if (!AuthService.GetToken()) {
      ApiConfig.FireUnauthorizedHandlers();
    } else if (ApiConfig._authRetryCount < MAX_AUTH_RETRY) {
      await this._retryRequest(response);
    } else {
      ApiConfig.FireUnauthorizedHandlers();
    }
  }

  private async _retryRequest(response: AxiosResponse) {
    ApiConfig._authRetryCount++;

    try {
      await new AuthService().RefreshToken();
    }
    catch (e) {
      ApiConfig.FireUnauthorizedHandlers();
      return;
    }

    response.config = this.transformHeaders(response.config);

    response = await axios.request(response.config);
    if (response.status == 401) {
      ApiConfig.FireUnauthorizedHandlers();
      return;
    }
  }

  getAuthorization(): string {
    return `Bearer ${AuthService.GetToken()}`;
  }

  static AddUnauthorizedHandler(handler: () => void) {
    if (ApiConfig.unAuthorizedHandlers == undefined)
      ApiConfig.unAuthorizedHandlers = new Array<() => void>();

    ApiConfig.unAuthorizedHandlers.push(handler);
  }

  static FireUnauthorizedHandlers() {
    ApiConfig.unAuthorizedHandlers.forEach(x => x());
    ApiConfig._authRetryCount = 0;
  }
}